import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignersSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { ISignerState } from '../store/completeChart.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setAnswer2() {
  const signerState: ISignerState = yield select(getSignersSelector)
  const { answer2, signer, signerList } = signerState
  const selectedAnswer2 = signerList.filter((u) => u.key === signer?.key)
  if (selectedAnswer2 && selectedAnswer2.length) {
    selectedAnswer2[0].answer2 = answer2
    yield put(setSignerList(signerList))
  }
}
export function* setAnswer2Saga() {
  yield takeLatest([CompleteChartConstants.SET_ANSWER2], performWithMutexHOG, setAnswer2)
}
